import { OriginalDialog } from "./OriginalDialog";

import type { MatchRules, PlayerCount } from "@marshmallow-duel/simulation";
import type { GamePreferences } from "../game/preferences";
import type { TranslationKey } from "../i18n";

interface SettingsDialogProps {
  readonly rules: MatchRules;
  readonly preferences: GamePreferences;
  readonly t: (key: TranslationKey) => string;
  readonly onChange: (rules: MatchRules) => void;
  readonly onPreferencesChange: (preferences: GamePreferences) => void;
  readonly onClose: () => void;
}

export const SettingsDialog = ({ rules, preferences, t, onChange, onPreferencesChange, onClose }: SettingsDialogProps) => (
  <OriginalDialog title={t("settings.title")} onClose={onClose} wide>
    <div className="settings-columns">
      <section className="settings-list">
        <h3>{t("settings.game")}</h3>
        <label>{t("settings.players")}<input type="number" min={2} max={4} value={rules.playerCount} onChange={(event) => onChange({ ...rules, playerCount: Math.max(2, Math.min(4, Number(event.target.value))) as PlayerCount })} /></label>
        <label>{t("settings.abilitiesCount")}<input type="number" min={0} max={48} value={rules.abilitiesCount} onChange={(event) => onChange({ ...rules, abilitiesCount: Math.max(0, Math.min(48, Number(event.target.value))) })} /></label>
        <label>{t("settings.winnerPoints")}<input type="number" min={1} max={99} value={rules.winnerPoints} onChange={(event) => onChange({ ...rules, winnerPoints: Math.max(1, Math.min(99, Number(event.target.value))) })} /></label>
        {(["randomSkull", "fighterAbility", "showScore", "saveWinner", "ropes", "shields", "physics"] as const).map((key) => key === "saveWinner"
          ? <label key={key} className="toggle-line"><input type="checkbox" checked={preferences.saveWinner} onChange={(event) => onPreferencesChange({ ...preferences, saveWinner: event.target.checked })} />{t("settings.saveWinner")}</label>
          : <label key={key} className="toggle-line"><input type="checkbox" checked={rules[key]} onChange={(event) => onChange({ ...rules, [key]: event.target.checked })} />{t(`settings.${key}`)}</label>)}
      </section>
      <section className="settings-list">
        <h3>{t("settings.viewSound")}</h3>
        {(["sound", "music", "raining", "screaming", "notifier", "showFps", "oldTextures", "gamepads"] as const).map((key) => <label key={key} className="toggle-line"><input type="checkbox" checked={preferences[key]} onChange={(event) => onPreferencesChange({ ...preferences, [key]: event.target.checked })} />{t(`settings.${key}`)}</label>)}
      </section>
    </div>
  </OriginalDialog>
);
